import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconLoadingStyle0 = cosmosIconCss;

const CosmosIconLoading$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconLoading extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '151b629617390c822de317fdef48c54dc6a5025d', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '7e9e06e3002ac38f0d2a3dcad89f8a09fa8aa986', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'c7ef07fb92d304d0f59efbbf829790168aefa186', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.25 2.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-4ZM2.5 10.25a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-4Zm13 0a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-4ZM10.75 15a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-.5Zm-6.294 2.196a.5.5 0 0 1 0-.707l2.828-2.828a.5.5 0 0 1 .708 0l.353.353a.5.5 0 0 1 0 .708L5.517 17.55a.5.5 0 0 1-.707 0l-.354-.354Zm9.2-9.917a.5.5 0 0 0 0 .707l.354.353a.5.5 0 0 0 .707 0l2.828-2.828a.5.5 0 0 0 0-.707l-.353-.354a.5.5 0 0 0-.708 0l-2.828 2.83ZM4.451 5.516a.5.5 0 0 1 0-.707l.353-.354a.5.5 0 0 1 .707 0L8.34 7.284a.5.5 0 0 1 0 .707l-.354.354a.5.5 0 0 1-.707 0L4.451 5.516Zm9.21 8.493a.5.5 0 0 0 0 .707l2.829 2.829a.5.5 0 0 0 .707 0l.354-.354a.5.5 0 0 0 0-.707l-2.829-2.829a.5.5 0 0 0-.707 0l-.354.354Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconLoadingStyle0; }
}, [1, "cosmos-icon-loading", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-loading"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-loading":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconLoading$1);
            }
            break;
    } });
}

const CosmosIconLoading = CosmosIconLoading$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconLoading, defineCustomElement };
